module.exports = __webpack_public_path__ + "static/media/embassy.c5958719.gif";